import createWidgetFactory from 'components-framework/widget/create_widget_factory';
import Model from './model';

const factory = createWidgetFactory({
    name: 'yearly_rejected_cards',
    modelClass: Model,
    methods: {
        checkYearlyRejectedCards(binNumber, offerId) {
            this.model.set({
                binNumber,
                offerId,
            });
        },
    },
});

export default factory;
